const ORIGINS = [
    {
        id: 1,
        pathname: "/project/2026/0902_join/",
        name: "主站链接"
    },
    {
        id: 2,
        pathname: "/project/2026/0902_join_baidu/",
        name: "百度链接"
    }
];

export default ORIGINS;
